/**
 * @fileoverview Local state for the second company address and branch visibility.
 */

import { useState } from "react";

/**
 * @param {Object} company - Company whose second address seeds the initial state
 */
export function useSecondAddressState(company) {
  const direccion = company?.direccion || [];
  const segundoDomicilio = direccion[1] || {};

  // Domicilio 2 (Comercial)
  const [segundoDomicilioCalle, setSegundoDomicilioCalle] = useState(
    segundoDomicilio?.calle || "",
  );
  const [segundoDomicilioMostrarCalle, setSegundoDomicilioMostrarCalle] =
    useState(segundoDomicilio?.mostrarCalle || false);
  const [segundoDomicilioNumeroExterior, setSegundoDomicilioNumeroExterior] =
    useState(segundoDomicilio?.numeroExterior || "");
  const [
    segundoDomicilioMostrarNumeroExterior,
    setSegundoDomicilioMostrarNumeroExterior,
  ] = useState(segundoDomicilio?.mostrarNumeroExterior || false);
  const [segundoDomicilioNumeroInterior, setSegundoDomicilioNumeroInterior] =
    useState(segundoDomicilio?.numeroInterior || "");
  const [
    segundoDomicilioMostrarNumeroInterior,
    setSegundoDomicilioMostrarNumeroInterior,
  ] = useState(segundoDomicilio?.mostrarNumeroInterior || false);
  const [segundoDomicilioEntreCalle1, setSegundoDomicilioEntreCalle1] =
    useState(segundoDomicilio?.entreCalle1 || "");
  const [
    segundoDomicilioMostrarEntreCalle1,
    setSegundoDomicilioMostrarEntreCalle1,
  ] = useState(segundoDomicilio?.mostrarEntreCalle1 || false);
  const [segundoDomicilioEntreCalle2, setSegundoDomicilioEntreCalle2] =
    useState(segundoDomicilio?.entreCalle2 || "");
  const [
    segundoDomicilioMostrarEntreCalle2,
    setSegundoDomicilioMostrarEntreCalle2,
  ] = useState(segundoDomicilio?.mostrarEntreCalle2 || false);
  const [segundoDomicilioCodigoPostal, setSegundoDomicilioCodigoPostal] =
    useState(segundoDomicilio?.codigoPostal || "");
  const [
    segundoDomicilioMostrarCodigoPostal,
    setSegundoDomicilioMostrarCodigoPostal,
  ] = useState(segundoDomicilio?.mostrarCodigoPostal || false);
  const [segundoDomicilioColonia, setSegundoDomicilioColonia] = useState(
    segundoDomicilio?.colonia || "",
  );
  const [segundoDomicilioMostrarColonia, setSegundoDomicilioMostrarColonia] =
    useState(segundoDomicilio?.mostrarColonia || false);
  const [segundoDomicilioMunicipio, setSegundoDomicilioMunicipio] = useState(
    segundoDomicilio?.municipio || "",
  );
  const [
    segundoDomicilioMostrarMunicipio,
    setSegundoDomicilioMostrarMunicipio,
  ] = useState(segundoDomicilio?.mostrarMunicipio || false);
  const [segundoDomicilioEstado, setSegundoDomicilioEstado] = useState(
    segundoDomicilio?.estado || "",
  );
  const [segundoDomicilioMostrarEstado, setSegundoDomicilioMostrarEstado] =
    useState(segundoDomicilio?.mostrarEstado || false);
  const [segundoDomicilioPais, setSegundoDomicilioPais] = useState(
    segundoDomicilio?.pais || "",
  );
  const [segundoDomicilioMostrarPais, setSegundoDomicilioMostrarPais] =
    useState(segundoDomicilio?.mostrarPais || false);
  const [sucursales, setSucursales] = useState(company?.sucursales || "");
  const [mostrarSucursales, setMostrarSucursales] = useState(
    company?.mostrarSucursales || false,
  );

  return {
    segundoDomicilioCalle,
    setSegundoDomicilioCalle,
    segundoDomicilioMostrarCalle,
    setSegundoDomicilioMostrarCalle,
    segundoDomicilioNumeroExterior,
    setSegundoDomicilioNumeroExterior,
    segundoDomicilioMostrarNumeroExterior,
    setSegundoDomicilioMostrarNumeroExterior,
    segundoDomicilioNumeroInterior,
    setSegundoDomicilioNumeroInterior,
    segundoDomicilioMostrarNumeroInterior,
    setSegundoDomicilioMostrarNumeroInterior,
    segundoDomicilioEntreCalle1,
    setSegundoDomicilioEntreCalle1,
    segundoDomicilioMostrarEntreCalle1,
    setSegundoDomicilioMostrarEntreCalle1,
    segundoDomicilioEntreCalle2,
    setSegundoDomicilioEntreCalle2,
    segundoDomicilioMostrarEntreCalle2,
    setSegundoDomicilioMostrarEntreCalle2,
    segundoDomicilioCodigoPostal,
    setSegundoDomicilioCodigoPostal,
    segundoDomicilioMostrarCodigoPostal,
    setSegundoDomicilioMostrarCodigoPostal,
    segundoDomicilioColonia,
    setSegundoDomicilioColonia,
    segundoDomicilioMostrarColonia,
    setSegundoDomicilioMostrarColonia,
    segundoDomicilioMunicipio,
    setSegundoDomicilioMunicipio,
    segundoDomicilioMostrarMunicipio,
    setSegundoDomicilioMostrarMunicipio,
    segundoDomicilioEstado,
    setSegundoDomicilioEstado,
    segundoDomicilioMostrarEstado,
    setSegundoDomicilioMostrarEstado,
    segundoDomicilioPais,
    setSegundoDomicilioPais,
    segundoDomicilioMostrarPais,
    setSegundoDomicilioMostrarPais,
    sucursales,
    setSucursales,
    mostrarSucursales,
    setMostrarSucursales,
  };
}
